import React, { Suspense } from "react";

import dwt from "dwt";
import { WebTwain } from "dwt/dist/types/WebTwain";
import { v4 } from "uuid";

import CircularProgress from "components/circular-progress";
import { viteEnv } from "utils/vite-env.util";

import { FolderSettings } from "./dynamic-web-twain-modal.component";

const Dynamsoft: any = dwt;

const DWTUserInterface = React.lazy(
  () => import("./dwt/dynamic-web-twain-interface.component")
);

export type ViewSize = {
  width: number;
  height: number;
};

export type Buffer = {
  updated: boolean;
  current: number;
  count: number;
};

export type Zone = {
  x: number;
  y: number;
  width: number;
  height: number;
};

type DynamicWebTwainProps = {
  onClose: () => void;
  submitButtonText: string;
  multiplePages?: boolean;
  folderSettings?: FolderSettings;
  onSave?: (file: File) => void;
};

type DynamicWebTwainState = {
  dwt: WebTwain | null;
  selected: number[];
  buffer: Buffer;
  zones: Zone[];
};

const PRODUCT_KEY = viteEnv.VITE_DYNAMSOFT_TWAIN_KEY;

export default class DynamicWebTwain extends React.Component<
  DynamicWebTwainProps,
  DynamicWebTwainState
> {
  constructor(props: DynamicWebTwainProps) {
    super(props);

    this.state = {
      dwt: null,
      selected: [],
      buffer: {
        updated: false,
        count: 0,
        current: -1
      },
      zones: []
    };
  }
  DWObject: WebTwain | null = null;
  containerId = "dwtcontrolContainer";
  width = 585;
  height = 513;
  modulizeInstallJS() {
    let _DWT_Reconnect = Dynamsoft.DWT_Reconnect;
    Dynamsoft.DWT_Reconnect = (...args: any[]) =>
      _DWT_Reconnect.call({ Dynamsoft: Dynamsoft }, ...args);
    let __show_install_dialog = Dynamsoft._show_install_dialog;
    Dynamsoft._show_install_dialog = (...args: any[]) =>
      __show_install_dialog.call({ Dynamsoft: Dynamsoft }, ...args);
    let _OnWebTwainOldPluginNotAllowedCallback =
      Dynamsoft.OnWebTwainOldPluginNotAllowedCallback;
    Dynamsoft.OnWebTwainOldPluginNotAllowedCallback = (...args: any[]) =>
      _OnWebTwainOldPluginNotAllowedCallback.call(
        { Dynamsoft: Dynamsoft },
        ...args
      );
    let _OnWebTwainNeedUpgradeCallback =
      Dynamsoft.OnWebTwainNeedUpgradeCallback;
    Dynamsoft.OnWebTwainNeedUpgradeCallback = (...args: any[]) =>
      _OnWebTwainNeedUpgradeCallback.call({ Dynamsoft: Dynamsoft }, ...args);
    let _OnWebTwainPostExecuteCallback =
      Dynamsoft.OnWebTwainPostExecuteCallback;
    Dynamsoft.OnWebTwainPostExecuteCallback = (...args: any[]) =>
      _OnWebTwainPostExecuteCallback.call({ Dynamsoft: Dynamsoft }, ...args);
    let _OnRemoteWebTwainNotFoundCallback =
      Dynamsoft.OnRemoteWebTwainNotFoundCallback;
    Dynamsoft.OnRemoteWebTwainNotFoundCallback = (...args: any[]) =>
      _OnRemoteWebTwainNotFoundCallback.call({ Dynamsoft: Dynamsoft }, ...args);
    let _OnRemoteWebTwainNeedUpgradeCallback =
      Dynamsoft.OnRemoteWebTwainNeedUpgradeCallback;
    Dynamsoft.OnRemoteWebTwainNeedUpgradeCallback = (...args: any[]) =>
      _OnRemoteWebTwainNeedUpgradeCallback.call(
        { Dynamsoft: Dynamsoft },
        ...args
      );
    let _OnWebTWAINDllDownloadFailure = Dynamsoft.OnWebTWAINDllDownloadFailure;
    Dynamsoft.OnWebTWAINDllDownloadFailure = (...args: any[]) =>
      _OnWebTWAINDllDownloadFailure.call({ Dynamsoft: Dynamsoft }, ...args);
  }
  componentDidMount() {
    var _this = this;

    Dynamsoft.Ready(function () {
      if (_this.DWObject === null && PRODUCT_KEY) {
        _this.loadDWT(true);
      }
    });
  }
  loadDWT(UseService: boolean) {
    Dynamsoft.OnLicenseError = function (message?: string, errorCode?: number) {
      if (errorCode === -2808)
        message =
          '<div style="padding:0">Sorry. Your product key has expired. You can purchase a full license at the <a target="_blank" href="https://www.dynamsoft.com/store/dynamic-web-twain/#DynamicWebTWAIN">online store</a>.</div><div style="padding:0">Or, you can try requesting a new product key at <a target="_blank" href="https://www.dynamsoft.com/customer/license/trialLicense?product=dwt&utm_source=in-product">this page</a>.</div><div style="padding:0">If you need any help, please <a target="_blank" href="https://www.dynamsoft.com/company/contact/">contact us</a>.</div>';
      Dynamsoft.DWT.ShowMessage(message, {
        width: 680,
        headerStyle: 2
      });
    };
    Dynamsoft.DWT.ResourcesPath = "/dwt-resources";
    Dynamsoft.DWT.ProductKey = PRODUCT_KEY;
    let innerLoad = (UseService: boolean) => {
      this.innerLoadDWT(UseService).then(
        (_DWObject) => {
          this.DWObject = _DWObject;
          if (
            this.DWObject.Viewer.bind(
              document.getElementById(this.containerId)!
            )
          ) {
            this.DWObject.Viewer.width = this.width;
            this.DWObject.Viewer.height = this.height;
            this.DWObject.Viewer.setViewMode(1, 1);
            this.DWObject.Viewer.show();
            this.setState({
              dwt: this.DWObject
            });
            if (this.DWObject) {
              /**
               * NOTE: RemoveAll doesn't trigger bitmapchanged nor OnTopImageInTheViewChanged!!
               */
              this.DWObject.RegisterEvent(
                "OnBitmapChanged",
                (changedIndex, changeType) =>
                  this.handleBufferChange(changedIndex, changeType)
              );
              this.DWObject.Viewer.on(
                "topPageChanged",
                (index, bByScrollBar) => {
                  if (bByScrollBar || this.DWObject?.isUsingActiveX()) {
                    this.go(index);
                  }
                }
              );
              this.DWObject.RegisterEvent("OnPostTransfer", () =>
                this.handleBufferChange()
              );
              this.DWObject.RegisterEvent("OnPostLoad", () =>
                this.handleBufferChange()
              );
              this.DWObject.RegisterEvent("OnBufferChanged", (e) => {
                if (e.action === "shift" && e.currentId !== -1) {
                  this.handleBufferChange();
                }
              });
              this.DWObject.RegisterEvent("OnPostAllTransfers", () =>
                this.DWObject?.CloseSource()
              );
              this.DWObject.Viewer.on(
                "pageAreaSelected",
                (nImageIndex, rect) => {
                  if (rect.length > 0) {
                    let currentRect = rect[rect.length - 1];
                    let oldZones = this.state.zones;
                    if (rect.length === 1) oldZones = [];
                    oldZones.push({
                      x: currentRect.x,
                      y: currentRect.y,
                      width: currentRect.width,
                      height: currentRect.height
                    });
                    this.setState({ zones: oldZones });
                  }
                }
              );
              this.DWObject.Viewer.on("pageAreaUnselected", () =>
                this.setState({ zones: [] })
              );
              this.DWObject.Viewer.on("click", () => {
                this.handleBufferChange();
              });
              if (Dynamsoft.Lib.env.bWin) this.DWObject.MouseShape = false;
              this.handleBufferChange();
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    };
    /**
     * ConnectToTheService is overwritten here for smoother install process.
     */
    Dynamsoft.DWT.ConnectToTheService = () => {
      innerLoad(UseService);
    };
    innerLoad(UseService);
  }
  innerLoadDWT(UseService: boolean): Promise<WebTwain> {
    return new Promise((res, rej) => {
      if (UseService !== undefined) Dynamsoft.DWT.UseLocalService = UseService;
      this.modulizeInstallJS();
      let dwtInitialConfig = {
        WebTwainId: v4()
      };
      Dynamsoft.DWT.CreateDWTObjectEx(
        dwtInitialConfig,
        (_DWObject: WebTwain) => {
          res(_DWObject);
        },
        (errorString: string) => {
          rej(errorString);
        }
      );
    });
  }
  go(index: number) {
    if (this.DWObject) {
      this.DWObject.CurrentImageIndexInBuffer = index;
    }
    this.handleBufferChange();
  }
  handleBufferChange(changedIndex?: number, changeType?: number) {
    let _updated = false;
    if (changeType === 4) {
      // Modified
      _updated = true;
    }

    let selection = this.DWObject?.SelectedImagesIndices;
    this.setState({
      //zones: [],
      selected: selection ?? [],
      buffer: {
        updated: _updated,
        current: this.DWObject?.CurrentImageIndexInBuffer ?? -1,
        count: this.DWObject?.HowManyImagesInBuffer ?? 0
      }
    });
  }

  handleViewerSizeChange(viewSize: ViewSize) {
    this.width = viewSize.width;
    this.height = viewSize.height;
  }
  render() {
    return (
      <Suspense
        fallback={<CircularProgress sx={{ width: "100%", height: 600 }} />}
      >
        <DWTUserInterface
          Dynamsoft={Dynamsoft}
          containerId={this.containerId}
          dwt={this.state.dwt as WebTwain}
          buffer={this.state.buffer}
          selected={this.state.selected}
          zones={this.state.zones}
          handleViewerSizeChange={(viewSize) =>
            this.handleViewerSizeChange(viewSize)
          }
          handleBufferChange={() => this.handleBufferChange()}
          onClose={this.props.onClose}
          folderSettings={this.props.folderSettings}
          multiplePages={this.props.multiplePages}
          submitButtonText={this.props.submitButtonText}
          onSave={this.props.onSave}
        />
      </Suspense>
    );
  }
}
